import { useState } from 'react'
import { useHistory } from 'react-router-dom'

import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import usePagination from 'hooks/usePagination'

import { useTheme } from '@material-ui/styles'
import { Skeleton } from '@material-ui/lab'
import {
  Box,
  Button,
  Card,
  Grid,
  Tab,
  Tabs,
  TablePagination,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import {
  Container,
  ContentHeader,
  FilterButton,
  Filters,
  Page,
  Permitted,
} from 'components'
import { ServiceCategoriesTable } from './components'

import { Plus as PlusIcon } from 'react-feather'

import constants from 'constants/index'
import * as service from 'service'

import useStyles from '../CompanyServices/styles'
import { routes } from 'Routes'

const ServiceCategoriesMain = () => {
  const classes = useStyles()
  const history = useHistory()
  const filter = useFilter()
  const theme = useTheme()
  const [loading, setLoading] = useState(false)
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const [currentTab, setCurrentTab] = useState(
    constants.serviceCategory.ANY_STATUS,
  )

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response, isLoading, refresh } = useFetch(
    service.marketPlace.serviceCategory.get,
    {
      status: currentTab,
      perPage,
      page,
      ...{ ...filter.filters },
    },
    [page, perPage, filter.filters],
  )

  const handleChangeTabs = (event, value) => {
    setCurrentTab(value)
    filter.setFilters({ ...filter.filters, status: value })
  }

  return (
    <Page title="Todos as categorias de serviços">
      <Container maxWidth={false} spacingXl={30} spacingLg={10}>
        <ContentHeader
          menu="Gerenciamentos"
          title="Categoria de serviço"
          subtitle="Listagem"
        >
          <FilterButton setDrawerOpen={filter.setDrawerOpen} />
        </ContentHeader>
        <Tabs
          scrollButtons="on"
          onChange={handleChangeTabs}
          textColor="primary"
          className={classes.borderBottom}
          indicatorColor="primary"
          value={currentTab}
          variant="scrollable"
        >
          {constants.serviceCategory.TABS.map((tab) => (
            <Tab key={tab.value} value={tab.value} label={tab.label} />
          ))}
        </Tabs>
        <Box mt={3}>
          <Card>
            <Box
              display="flex"
              width="100%"
              p={0}
              className={classes.borderBottom}
            >
              <Grid container>
                <Grid item xs={6}>
                  <Box
                    width="100%"
                    p={2}
                    height="100%"
                    display="flex"
                    alignItems="center"
                  >
                    <Typography variant="h5">Categoria de serviços</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box p={2} display="flex" justifyContent="flex-end">
                    <Permitted
                      tag={constants.permissions.SERVICE_CATEGORIES.CREATE}
                    >
                      <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<PlusIcon />}
                        onClick={() =>
                          history.push(routes.serviceCategories.new)
                        }
                      >
                        Criar
                      </Button>
                    </Permitted>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box display="flex" width="100%">
              <Grid container>
                <ServiceCategoriesTable
                  serviceCategories={response?.data?.serviceCategories}
                  isLoading={isLoading || loading}
                  onEvent={refresh}
                  setLoading={setLoading}
                />
              </Grid>
            </Box>
            <Box px={2} display="flex" justifyContent="flex-end">
              {!isLoading || loading ? (
                <TablePagination
                  component="div"
                  count={response?.data?.meta?.totalCount}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  page={page - 1}
                  rowsPerPage={perPage}
                  rowsPerPageOptions={[5, 10, 25, 100]}
                  labelRowsPerPage={isDesktop ? 'Por página' : ''}
                  nextIconButtonProps={{ size: 'small' }}
                  backIconButtonProps={{ size: 'small' }}
                />
              ) : (
                <Box py="11px">
                  <Skeleton variant="rect" width={200} height={30} />
                </Box>
              )}
            </Box>
          </Card>
        </Box>
        <Filters filter={filter}>
          <input textfieldinput="true" label="Identificador" name="id" />
          <input textfieldinput="true" label="Nome" name="name" />
        </Filters>
      </Container>
    </Page>
  )
}

export default ServiceCategoriesMain
